module.exports = __webpack_public_path__ + "static/media/arrow-l.7a08cfc7.svg";